import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { FabricItem } from 'features/fabrics/types/fabrics.types'

type UseCreateFabricMutationProps = {
	onSuccess: () => void
}

export const useCreateFabricMutation = ({ onSuccess }: UseCreateFabricMutationProps) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: createFabric, isPending: createFabricLoading } = useMutation({
		mutationFn: (data: Pick<FabricItem, 'name'>) => {
			return axiosPrivate.post(apiRoutes.fabrics(''), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.fabrics.all })
			useToast({ type: 'success', message: t('New fabric created!') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createFabric,
		createFabricLoading
	}
}
